import { Search, Upload } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

interface ImagesFiltersProps {
  searchInput: string
  onSearchChange: (value: string) => void
  onUploadClick: () => void
}

export function ImagesFilters({
  searchInput,
  onSearchChange,
  onUploadClick,
}: ImagesFiltersProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-border bg-card p-3">
      {/* Search Input */}
      <div className="relative flex-1 max-w-[352px]">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search by name or description..."
          value={searchInput}
          onChange={e => onSearchChange(e.target.value)}
          className="pl-9 bg-muted/50"
        />
      </div>

      <div className="flex-1" />

      {/* Upload Button */}
      <Button onClick={onUploadClick} className="cursor-pointer">
        <Upload className="mr-2 h-4 w-4" />
        Upload Images
      </Button>
    </div>
  )
}
